export class AuthService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    async login(email, password) {
        const response = await this.apiService.post('auth', { email, password });
        if (!response.ok) {
            throw new Error('Ha ocurrio un error al efectuar el login.');
        }
        const content = await response.json();
        return content.accessToken;
    }
}
